<template>
<section>
    <!--工具条-->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
        <el-form :inline="true" :model="filters">
            <el-form-item>
                <el-button type="primary" @click="handleAdd">增加屏蔽号段</el-button>
            </el-form-item>
        </el-form>
    </el-col>

    <!--列表-->
    <el-table :data="cards" highlight-current-row v-loading="listLoading" @selection-change="selsChange" style="width: 100%;">

        <el-table-column prop="cardno_begin" label="卡号开始" min-width="150" sortable>
        </el-table-column>
        <el-table-column prop="cardno_end" label="卡号截止" min-width="150" sortable>
        </el-table-column>
        <el-table-column prop="should_cardnum" label="应屏蔽数量" min-width="150" sortable>
        </el-table-column>
        <el-table-column prop="real_cardnum" label="实际屏蔽数" min-width="150" sortable>
        </el-table-column>
        <el-table-column prop="edittime" label="更新时间" min-width="150" sortable>
        </el-table-column>
        <el-table-column label="操作" width="100" fixed="right">
            <template scope="scope">
                <el-button type="danger" size="small" @click="handleDel(scope.$index, scope.row)">解除限制</el-button>
            </template>
        </el-table-column>
    </el-table>

    <!--工具条-->
    <el-col :span="24" class="toolbar">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" style="float:right;">
        </el-pagination>
    </el-col>

    <!--新增界面-->
    <el-dialog title="增加屏蔽号段" :visible.sync="addFormVisible" :close-on-click-modal="false">
        <el-form :model="addForm" label-width="100px" :rules="addFormRules" ref="addForm">
            <el-form-item label="开始卡号：" prop="cardnoBt">
                <el-input v-model="addForm.cardnoBt" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="截止卡号：" prop="cardnoEt">
                <el-input v-model="addForm.cardnoEt" auto-complete="off"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click.native="addFormVisible = false">取消</el-button>
            <el-button type="primary" @click.native="addSubmit" :loading="addLoading">保存</el-button>
        </div>
    </el-dialog>
</section>
</template>

<script>
import util from '../../common/js/util'
import constant from '../../common/js/constant'
//import NProgress from 'nprogress'
import {
    getNoBalanceCardSegListPage,
    enabledShowBalanceCards,
    disabledShowBalanceCards
} from '../../api/api';

export default {
    data() {

        return {
            filters: {
                //卡号段开始
                cardSegBt: '',
                //卡号段截止
                cardSegEt: '',
                //模糊查询卡关键字
                likeCardKey: ''
            },
            cards: [],
            total: 0, //列表总条数
            pageSize: 10, //每页条数
            currentPage: 1, //当前页码
            listLoading: false,
            sels: [], //列表选中列

            addFormVisible: false, //新增界面是否显示
            addLoading: false,
            addFormRules: {
                cardnoBt: [{
                    required: true,
                    min: 6,
                    message: '请输入开始卡号(必须为6个字符或以上)',
                    trigger: 'blur'
                }],
                cardnoEt: [{
                    required: true,
                    min: 6,
                    message: '请输入截止卡号(必须为6个字符或以上)',
                    trigger: 'blur'
                }]
            },
            //新增界面数据
            addForm: {
                cardnoBt: '',
                cardnoEt: ''
            }

        }
    },
    methods: {
        handleSizeChange(val) {
            this.pageSize = val;
            this.getDisabledCards();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.getDisabledCards();
        },
        //获取已屏蔽的卡号列表
        getDisabledCards() {
            let para = {
                pageSize: this.pageSize,
                pageNum: this.currentPage
            };
            para = Object.assign(para, this.filters);

            this.listLoading = true;
            //NProgress.start();
            getNoBalanceCardSegListPage(para).then((res) => {
                this.total = res.data.total;
                this.cards = res.data.list;
                this.listLoading = false;
                //NProgress.done();
            });
        },
        //解除限制
        handleDel: function (index, row) {
            this.$confirm('确认允许此卡段范围内的微信用户查看余额信息吗?', '提示', {
                type: 'warning'
            }).then(() => {
                this.listLoading = true;
                //NProgress.start();
                let para = {
                    cardnoBt: row.cardno_begin,
                    cardnoEt: row.cardno_end
                };
                enabledShowBalanceCards(para).then((res) => {
                    this.listLoading = false;
                    //NProgress.done();
                    this.$message({
                        message: '解除限制成功',
                        type: 'success'
                    });
                    this.getDisabledCards();
                });
            }).catch(() => {

            });
        },
        //显示新增界面
        handleAdd: function () {
            this.addFormVisible = true;
            this.addForm = {
                cardnoBt: '',
                cardnoEt: ''
            };
        },
        //新增
        addSubmit: function () {
            this.$refs.addForm.validate((valid) => {
                if (valid) {
                    this.$confirm('确认提交吗？', '提示', {}).then(() => {
                        this.addLoading = true;
                        //NProgress.start();
                        let para = Object.assign({}, this.addForm);
                        disabledShowBalanceCards(para).then((res) => {
                            this.addLoading = false;
                            //NProgress.done();

                            let {
                                msg,
                                code
                            } = res;
                            if (code !== 0) {
                                this.$message({
                                    message: msg,
                                    type: 'error'
                                });
                            } else {
                                this.$message({
                                    message: '提交成功',
                                    type: 'success'
                                });
                                this.$refs['addForm'].resetFields();
                                this.addFormVisible = false;
                                this.getDisabledCards();
                            }

                        });
                    });
                }
            });
        },
        selsChange: function (sels) {
            this.sels = sels;
        },
        //批量删除
        batchRemove: function () {
            var ids = this.sels.map(item => item.id).toString();
            this.$confirm('确认删除选中记录吗？', '提示', {
                type: 'warning'
            }).then(() => {
                this.listLoading = true;
                //NProgress.start();
                let para = {
                    ids: ids
                };
                batchRemoveUser(para).then((res) => {
                    this.listLoading = false;
                    //NProgress.done();
                    this.$message({
                        message: '删除成功',
                        type: 'success'
                    });
                    this.getDisabledCards();
                });
            }).catch(() => {

            });
        }
    },
    mounted() {
        this.getDisabledCards();
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// noshowbalance.vue?f2c7e210